import React from 'react';
import { Box, SvgIconProps } from '@mui/material';
import EqualizerOutlined from '@mui/icons-material/EqualizerOutlined';
import BarChartOutlined from '@mui/icons-material/BarChartOutlined';
import ShowChartOutlined from '@mui/icons-material/ShowChartOutlined';
import InsightsOutlined from '@mui/icons-material/InsightsOutlined';
import PieChartOutlineOutlined from '@mui/icons-material/PieChartOutlineOutlined';
import PaidOutlined from '@mui/icons-material/PaidOutlined';
import ReceiptLongOutlined from '@mui/icons-material/ReceiptLongOutlined';
import ReceiptOutlined from '@mui/icons-material/ReceiptOutlined';
import StorefrontOutlined from '@mui/icons-material/StorefrontOutlined';
import DeliveryDiningOutlined from '@mui/icons-material/DeliveryDiningOutlined';
import LocalShippingOutlined from '@mui/icons-material/LocalShippingOutlined';
import Inventory2Outlined from '@mui/icons-material/Inventory2Outlined';
import NotificationsNoneOutlined from '@mui/icons-material/NotificationsNoneOutlined';
import ScheduleOutlined from '@mui/icons-material/ScheduleOutlined';
import SmartphoneOutlined from '@mui/icons-material/SmartphoneOutlined';
import RestaurantOutlined from '@mui/icons-material/RestaurantOutlined';
import RestaurantMenuOutlined from '@mui/icons-material/RestaurantMenuOutlined';
import BlenderOutlined from '@mui/icons-material/BlenderOutlined';
import EggAltOutlined from '@mui/icons-material/EggAltOutlined';
import LocalFireDepartmentOutlined from '@mui/icons-material/LocalFireDepartmentOutlined';
import TrendingDownOutlined from '@mui/icons-material/TrendingDownOutlined';
import TrendingUpOutlined from '@mui/icons-material/TrendingUpOutlined';
import WarningAmberOutlined from '@mui/icons-material/WarningAmberOutlined';
import PriorityHighOutlined from '@mui/icons-material/PriorityHighOutlined';
import ErrorOutlineOutlined from '@mui/icons-material/ErrorOutlineOutlined';
import DeleteOutlineOutlined from '@mui/icons-material/DeleteOutlineOutlined';
import DeleteOutlined from '@mui/icons-material/DeleteOutlined';
import RecyclingOutlined from '@mui/icons-material/RecyclingOutlined';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import EditNoteOutlined from '@mui/icons-material/EditNoteOutlined';
import CheckBoxOutlined from '@mui/icons-material/CheckBoxOutlined';
import FactCheckOutlined from '@mui/icons-material/FactCheckOutlined';
import CompareArrowsOutlined from '@mui/icons-material/CompareArrowsOutlined';
import SentimentSatisfiedOutlined from '@mui/icons-material/SentimentSatisfiedOutlined';
import SentimentDissatisfiedOutlined from '@mui/icons-material/SentimentDissatisfiedOutlined';
import SmartToyOutlined from '@mui/icons-material/SmartToyOutlined';
import CancelOutlined from '@mui/icons-material/CancelOutlined';
import LightbulbOutlined from '@mui/icons-material/LightbulbOutlined';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import ShoppingCartOutlined from '@mui/icons-material/ShoppingCartOutlined';
import PercentOutlined from '@mui/icons-material/PercentOutlined';
import StarOutlineOutlined from '@mui/icons-material/StarOutlineOutlined';
import BalanceOutlined from '@mui/icons-material/BalanceOutlined';
import ShoppingBasketOutlined from '@mui/icons-material/ShoppingBasketOutlined';
import PersonOutlineOutlined from '@mui/icons-material/PersonOutlineOutlined';
import TimelineOutlined from '@mui/icons-material/TimelineOutlined';
import AssessmentOutlined from '@mui/icons-material/AssessmentOutlined';
import HistoryOutlined from '@mui/icons-material/HistoryOutlined';
import CheckCircleOutlineOutlined from '@mui/icons-material/CheckCircleOutlineOutlined';
import BlockOutlined from '@mui/icons-material/BlockOutlined';
import SettingsOutlined from '@mui/icons-material/SettingsOutlined';
import LogoutOutlined from '@mui/icons-material/LogoutOutlined';
import SupportAgentOutlined from '@mui/icons-material/SupportAgentOutlined';
import HelpOutlineOutlined from '@mui/icons-material/HelpOutlineOutlined';

const MAP: Record<string, React.ComponentType<SvgIconProps>> = {
  'icons8-statistics-100': EqualizerOutlined,
  'icons8-bar-chart-100': BarChartOutlined,
  'icons8-line-chart-100': ShowChartOutlined,
  'icons8-combo-chart-100': InsightsOutlined,
  'icons8-pie-chart-100': PieChartOutlineOutlined,
  'icons8-area-chart-100': TimelineOutlined,
  'icons8-business-report-100': AssessmentOutlined,
  'icons8-banknotes-100': PaidOutlined,
  'icons8-purchase-order-100': ReceiptLongOutlined,
  'icons8-cheque-100': ReceiptOutlined,
  'icons8-online-store-100': StorefrontOutlined,
  'icons8-bike-94': DeliveryDiningOutlined,
  'icons8-shipped-100': LocalShippingOutlined,
  'icons8-delivery-box-100': Inventory2Outlined,
  'icons8-bell-94': NotificationsNoneOutlined,
  'icons8-realtime-100': ScheduleOutlined,
  'icons8-clock-100': ScheduleOutlined,
  'icons8-phone-94': SmartphoneOutlined,
  'icons8-restaurant-94': RestaurantOutlined,
  'icons8-thanksgiving-94': RestaurantMenuOutlined,
  'icons8-rice-bowl-94': RestaurantMenuOutlined,
  'icons8-egg-94': EggAltOutlined,
  'icons8-ingredients-94': BlenderOutlined,
  'icons8-ingredient-94': BlenderOutlined,
  'icons8-fire-96': LocalFireDepartmentOutlined,
  'icons8-icde-96': TrendingDownOutlined,
  'icons8-increase-100': TrendingUpOutlined,
  'icons8-spam-100': WarningAmberOutlined,
  'icons8-high-priority-100': PriorityHighOutlined,
  'icons8-error-100': ErrorOutlineOutlined,
  'icons8-trash-can-100': DeleteOutlineOutlined,
  'icons8-full-trash-100': DeleteOutlined,
  'icons8-leave-100': RecyclingOutlined,
  'icons8-edit-property-100': DescriptionOutlined,
  'icons8-edit-file-100': EditNoteOutlined,
  'icons8-tick-box-100': CheckBoxOutlined,
  'icons8-inspection-100': FactCheckOutlined,
  'icons8-venn-diagram-100': CompareArrowsOutlined,
  'icons8-smile-94': SentimentSatisfiedOutlined,
  'icons8-loudly-crying-face-94': SentimentDissatisfiedOutlined,
  'icons8-robot-94': SmartToyOutlined,
  'icons8-cancle-94': CancelOutlined,
  'icons8-idea-100': LightbulbOutlined,
  'icons8-about-96': InfoOutlined,
  'icons8-buy-100': ShoppingCartOutlined,
  'icons8-percent-96': PercentOutlined,
  'icons8-star-100': StarOutlineOutlined,
  'icons8-scale-94': BalanceOutlined,
  'icons8-basket1-96': ShoppingBasketOutlined,
  'icons8-basket2-96': ShoppingBasketOutlined,
  'icons8-profile-100': PersonOutlineOutlined,
  'icons8-time-machine-100': HistoryOutlined,
  'icons8-check-mark-100': CheckCircleOutlineOutlined,
  'icons8-checkmark-100': CheckCircleOutlineOutlined,
  'icons8-do-not-disturb-100': BlockOutlined,
  'icons8-customer-100': PersonOutlineOutlined,
  'icons8-test-account-100': PersonOutlineOutlined,
  'icons8-settings-100': SettingsOutlined,
  'icons8-logout-100': LogoutOutlined,
  'icons8-cs-94': SupportAgentOutlined
};

export function reportRankNumber(file: string): number | null {
  const m = /^icons8-(\d{1,2})-100$/.exec(file);
  if (!m) return null;
  const n = Number(m[1]);
  return n >= 1 && n <= 10 ? n : null;
}

export function reportIconComponent(file: string): React.ComponentType<SvgIconProps> {
  return MAP[file] || HelpOutlineOutlined;
}

export interface ReportHdrIconProps {
  file: string;
  w?: number;
}

/** Icons8 PNG 파일명을 라인 아이콘(또는 순번 배지)으로 렌더 */
const ReportHdrIcon: React.FC<ReportHdrIconProps> = ({ file, w = 20 }) => {
  const rank = reportRankNumber(file);
  if (rank !== null) {
    return (
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          width: w + 4,
          height: w + 4,
          borderRadius: '50%',
          bgcolor: rank <= 3 ? 'primary.main' : 'action.hover',
          color: rank <= 3 ? '#fff' : 'text.secondary',
          fontSize: Math.max(10, w - 4),
          fontWeight: 700,
          fontVariantNumeric: 'tabular-nums',
          lineHeight: 1
        }}
      >
        {rank}
      </Box>
    );
  }
  const Cmp = reportIconComponent(file);
  return (
    <Box component="span" sx={{ lineHeight: 0, display: 'inline-flex', alignItems: 'center', flexShrink: 0 }}>
      <Cmp sx={{ fontSize: w, color: 'text.secondary' }} />
    </Box>
  );
};

export default ReportHdrIcon;
